$('document').ready(function(){
   // for installation matched 
  // using app code
  var selectedValue = $('select[name="ymq[Colour ]"]').val();
            console.log("Initial selected value:", selectedValue); // Print the selected value to the console

            // Update the selected value whenever the selection changes
            $('select[name="ymq[Colour ]"]').change(function(){
                console.log("select")
                selectedValue = $(this).val();
                console.log("Updated selected value:", selectedValue);
                $('.Color_informapp p.title').text(selectedValue);
            });
  // get starting option values
  var colorvalue = $('.option_Colour').val();
var installvalue = $('.option_Installation').val();
var frigevalue = $('.option_Freight').val();
var option_Extra = $('.option_Extra').val();
if (colorvalue === "Select an option..." || installvalue === "Select an option..." || frigevalue === "Select an option..." || option_Extra=== 'none') {
    $('.product-form__submit').addClass('activedisable');
} else {
    $('.product-form__submit').removeClass('activedisable');
}
$('.select__select ').on('change',function(){
    var colorvalue = $('.option_Colour').val();
var installvalue = $('.option_Installation').val();
var frigevalue = $('.option_Freight').val();

if (colorvalue === "Select an option..." || installvalue === "Select an option..." || frigevalue === "Select an option...") {
    $('.product-form__submit').addClass('activedisable');
} else {
    $('.product-form__submit').removeClass('activedisable');
}
})
  // end options values
 var url = window.location.pathname;
  console.log(url)
 $(".header__inline-menu ul.list-menu li").each(function() {
if ($(this).find("a.header__menu-item").attr("href") ===  url) {
  $(this).addClass("active_menu");
 }
   
});
  if(url == '/account/login'){
    $('ul.list-menu.list-menu--inline li:last').addClass("active_menu");
  }
  
  
  $('.custom_cart').on('click',function(){
  $(this).addClass('on');
  $('cart-drawer.drawer').addClass('active')
})
  $('button.drawer__close').on('click',function(){
     $('.custom_cart').removeClass('active')
  })
  
  $('span#eyeButton i.fa.fa-eye').on('click', function() {
  var passwordInput = $('input#CustomerPassword');
  var eyeButton = $('#eyeButton');
  
  if (passwordInput.attr('type') === 'password') {
    passwordInput.attr('type', 'text');
    // eyeButton.text(''); // Change this to your "eye closed" icon
  } else {
    passwordInput.attr('type', 'password');
    // eyeButton.text('️'); // Change this to your "eye open" icon
  }
});

// check screen size 

   function checkScreenWidth() {
                if ($(window).width() < 789) {
                    
                }
            }
            checkScreenWidth();
            $(window).resize(function() {
                checkScreenWidth();
            });

  // product btn
  $('.product-form__submit').on('click',function(){
    $('.custom_cart').trigger('click');
    var value = parseInt($('span.xoo-wsc-items-count').text());
                console.log(value);
   setTimeout(function() {
                var update  = value+1;
            $('span.xoo-wsc-items-count').text(update);
            }, 600);
  
})
   
 $('.option_Colour').on('change', function() {
    var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
     if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.feature_inform').next().html(
        "<div class='string_inform'>Colour - " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
});
  // for second option AFN
  $('.option_Installation').on('change', function() {
    var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.Color_inform').next().html(
        "<div class='string_inform'>Installation / Fitting Required -" + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
});
  // for third option AFN
  $('.option_Freight').on('change', function() {
    var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.sensor_inform').next().html(
        "<div class='string_inform'>Freight - " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
});
  // for xtra option
$('.option_Extra').on('change', function() {
    var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
         numberPart = numberPart.replace(/[()+]/g, ''); 
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.extraoption_inform').html(
        "<div class='string_inform'>Extra Options -  " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
});
// show price

  $('.select__select ').on('change',function(){
    
  setTimeout(function() {
    let latestprice =  $('.product__info-container .price__regular.final_csrt.price__regular.final_csrt span.price-item.price-item--regular').text();
console.log(latestprice);
    $('.total_inform span.custom_df').hide();
    $('.total_inform span.value_price').text(latestprice);
}, 1000);

  })
  
  // frights
  $('select#parking-sensors-headlight-washers').on('change',function(){
    let selectedValue = $('select#parking-sensors-headlight-washers').val();
    
    // Find the radio button with the matching value and check it
    $('p.line-item-property__field.custom_parking-sensors-headlight-washers input[type="radio"]').each(function() {
        if ($(this).val() === selectedValue) {
            $(this).prop('checked', true);
        }
    });
      // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.install_inform').html(
        "<div class='string_inform'>Freight - " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
    
  })
  // Gauge Kit

   $('.option_Gauge').on('change',function(){
   var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
         numberPart = numberPart.replace(/[()+]/g, ''); 
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.option_Gaugecrt').html(
        "<div class='string_inform'>Extra Options -  " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
    
  })
// option_Airline 
   $('.option_Airline').on('change',function(){
   var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
         numberPart = numberPart.replace(/[()+]/g, ''); 
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.option_Airlinecrst').html(
        "<div class='string_inform'>Extra Options -  " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
    
  })
  // option_Remote 
  $('.option_Remote').on('change',function(){
   var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
         numberPart = numberPart.replace(/[()+]/g, ''); 
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.option_Remotecsrt').html(
        "<div class='string_inform'>Extra Options -  " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
    
  })
  // line-item-property__fieldInstallation
 $('.line-item-property__fieldInstallation').on('change',function(){
   var selectedValue = $(this).val();
    console.log(selectedValue);

    // Use a regular expression to extract the parts
    var parts = selectedValue.match(/(.*?)(\(\+\$[0-9,]+\))/);

    var stringPart = '';
    var numberPart = '';

    if (parts) {
        stringPart = parts[1].trim(); // The text part
        numberPart = parts[2].trim(); // The number part
         numberPart = numberPart.replace(/[()+]/g, ''); 
    } else {
        stringPart = selectedValue.trim(); // If no match, treat the whole value as string part
    }
  if (!numberPart) {
        numberPart = "-";
    }
    // Insert into the respective divs
    $('.line-item-property__fieldInstallation_csrt').html(
        "<div class='string_inform'>Extra Options -  " + stringPart + "</div>" +
        "<div class='number_inform'>" + numberPart + "</div>"
    );
    
  })

 
  
});


$(document).on('click', 'td.cross .cross_csrty', function() {
    $(this).addClass("oncross");
    var id = $(this).closest('tr').attr('id');
    console.log(id);
    var quantityValueId = $(this).closest('tr').find('td.cart-item__quantity').attr('cartvalue');
    console.log(quantityValueId);

    if (quantityValueId == id) {
        $(this).closest('tr').find('cart-remove-button').trigger('click');
    }
});



